import React from 'react';

export const CloseModal = () => {
  return (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1.46226L7.5377 1L4.5 4.03772L1.4623 1L1 1.46226L4.03772 4.5L1 7.53774L1.4623 8L4.5 4.96228L7.5377 8L8 7.53774L4.96228 4.5L8 1.46226Z"
        fill="#F32645"
        stroke="#F32645"
        strokeWidth="0.5"
      />
    </svg>
  );
};
